//MAIN
import { createApp } from 'vue'
import App from './App.vue'

//VUETIFYJS
import vuetify from './plugins/vuetify'

//FONTS
import { loadFonts } from './plugins/webfontloader'

//ROUTER
import router from './router'

//STORE
import store from './store'

//AXIOS (con interceptor per token e logout forzato, vedi plugins/axios.js)
import api from './plugins/axios'
import VueAxios from 'vue-axios'

//NOTIFICHE SWEET ALERT
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


import './assets/css/main.css'

//import Spinner from '@/components/Spinner.vue';



loadFonts()


const app = createApp(App)
//app.component('Spinner', Spinner); // Registrazione globale

// Configurazione globale
app.config.globalProperties.$swal = Swal

app
  .use(store)
  .use(router)
  .use(VueAxios, api)
  .use(vuetify)
  .mount('#app')